import React from "react";
import { Tab, Tabs, Box } from "@mui/material";
import { useTranslate } from "src/locales";
import type { RequestListTabValue } from "../types";

interface RequestListTabsProps {
  value: RequestListTabValue;
  onChange: (value: RequestListTabValue) => void;
}

const TAB_VALUES: { value: RequestListTabValue; labelKey: string }[] = [
  { value: "completed", labelKey: "request-list.tabs.completed" },
  { value: "pending", labelKey: "request-list.tabs.pending" },
  { value: "all", labelKey: "request-list.tabs.all" },
  { value: "all-arrivals", labelKey: "request-list.tabs.all-arrivals" },
];

export default function RequestListTabs({ value, onChange }: RequestListTabsProps) {
  const { t } = useTranslate();

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        mb: 2,
        minHeight: 0,
      }}
    >
      <Tabs
        value={value}
        onChange={(_, newValue: RequestListTabValue) => onChange(newValue)}
        sx={{
          minHeight: 0,
          px: 0,
          minWidth: 0,
          "& .MuiTabs-flexContainer": {
            gap: 0,
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "primary.main",
            height: 2,
          },
          "& .MuiTab-root": {
            minHeight: 48,
            minWidth: 0,
            textTransform: "none",
            fontSize: 14,
            fontWeight: 600,
            px: 2,
            "&.Mui-selected": {
              color: "primary.main",
            },
          },
        }}
      >
        {TAB_VALUES.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={t(tab.labelKey, "default", {
              defaultValue:
                tab.value === "completed"
                  ? "Yapılan İstekler"
                  : tab.value === "pending"
                    ? "Bekleyen Tüm İstekler"
                    : tab.value === "all"
                      ? "Tüm İstekler"
                      : "Tüm Gelişlerdeki İstekler",
            })}
          />
        ))}
      </Tabs>
    </Box>
  );
}
